import { Route, Routes } from "react-router-dom";
import NewFlight from "./aviation/NewFlight";
import SelectPaymentMethod from "./aviation/SelectPaymentMethod";
import PayNow from "./aviation/PayNow";
import PayLater from "./aviation/PayLater";
import BookedFlights from "./aviation/BookedFlights";
import SearchFlight from "./aviation/international/SearchFlight";
import SearchResults from "./aviation/international/SearchResults";
import IntlSearchFlightV2 from "./aviation/international-v2/SearchFlight";
import IntlSearchResultsV2 from "./aviation/international-v2/SearchResults";
import IntlReviewAndBookV2 from "./aviation/international-v2/ReviewAndBook";
import IntlFlightDetailsV2 from "./aviation/international-v2/FlightDetails";
import AviationHome from "./aviation/AviationHome";
import FlightDetails from "./aviation/FlightDetails";
import { AviationFlightsPage } from "../../features/aviation-flights-booking";

// Booking is open to everyone — the account-setup gate now lives on the BNPL
// payment option (see useBnplGate), not on the whole aviation flow.
const Aviation = () => {
  return (
    <Routes>
      <Route path="/" element={<AviationHome />} />
      <Route path="/new-local-flight" element={<NewFlight />} />
      <Route path="/flights" element={<AviationFlightsPage />} />
      <Route path="/your-flights" element={<BookedFlights />} />
      <Route path="/flight/:id" element={<FlightDetails />} />
      <Route path="/select-payment-method" element={<SelectPaymentMethod />} />
      <Route path="/pay-now" element={<PayNow />} />
      <Route path="/pay-later" element={<PayLater />} />
      <Route path="/international/new-flight" element={<SearchFlight />} />
      <Route path="/international/search-results" element={<SearchResults />} />
      <Route path="/international/v2/search" element={<IntlSearchFlightV2 />} />
      <Route path="/international/v2/results" element={<IntlSearchResultsV2 />} />
      <Route path="/international/v2/review" element={<IntlReviewAndBookV2 />} />
      <Route path="/international/v2/bookings/:bookingId" element={<IntlFlightDetailsV2 />} />
    </Routes>
  );
};

export default Aviation;
